import "phaser";

import * as platform from "./platform";

// Load the json for the test level
let jsonData = require("json-loader!../levels/test1.json");

export function getTestLevelJson(): any {
  return jsonData;
}

export function getLevelJson(name: string): any {
  let json = require(`json-loader!../levels/${name}.json`);
  json.name = name;
  return json;
}



// WEBPACK FOOTER //
// ./src/leveljson.ts